export const BET_ACTIONS = {
  BET: 'BET',
  SAVE: 'SAVE',
  FREE: 'FREE'
};
